<div class="notification-container">
    <button (click)="showNotification()">Show Notification</button>
  </div>